import React from "react";

import PropTypes from "prop-types";

import { connect } from "react-redux";
import { Link } from "react-router";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { FormControl, Select, TextField } from "@mui/material";

// material-ui icons
import { Add, CenterFocusStrong, ConfirmationNumber, DeleteForeverRounded, SaveAlt } from "@mui/icons-material";

import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import { convertArrayToSelectOptions } from "../../templateHelpers";
import * as actions from "../../store/actions";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import DownloadVoucherQRCodes from "./Modals/DownloadVoucherQRCodes";
import axios from "axios";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import { toast } from "react-toastify";
import { differenceInDays } from "date-fns";

class Index extends React.Component {
  state = {
    selectedIds: [],

    showDeleteAlert: false,

    DownloadQRCodeModal: false,
  };

  /* gridText vars */
  gridTextSingleUsed = getTranslation("vouchers.grid.toggle.singleUse", "SINGLE");
  gridTextFinalClosed = getTranslation("vouchers.grid.toggle.final", "CLOSED");

  jamezzTable = React.createRef();

  componentWillUnmount() {
    /**
     * Current request annuleren bij snel klikken kan zijn dat die nog niet klaar is
     */
    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }
  }

  // final_customData = (tableRecord) => {
  //     console.log(tableRecord.final);
  //     //return tableRecord.finale;
  //     //return "hello";
  //     if (tableRecord.final == 0){
  //         return "open";
  //     } else {
  //         return "CLOSED";
  //     }
  // }

  currentRequest;

  downloadVoucherCodes = () => {
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);

    this.jamezzTable.current?.refreshData();

    this.setState({ saving: true });

    const data = {
      voucherIds: this.state.selectedIds,
    };

    if (this.currentRequest !== undefined) {
      this.currentRequest.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentRequest = CancelToken.source();
    let cancelToken = this.currentRequest.token;

    axios
      .post("core/vouchers/downloadVoucherCodes", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let linkDataFile = response.data.data.url;
        window.location.href = linkDataFile;
      })

      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         **/
        if (!error.__CANCEL__) {
          toast.warn(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  customRender_final = (tableField) => {
    if (tableField !== undefined) {
      if (tableField == 0) {
        return "<span><center>" + "-" + "</center></span>";
      } else {
        return "<span><center>" + this.gridTextFinalClosed + "</center></span>";
      }
      //return '<Chip label="'+ tableField +'" color="secondary" />';
    } else {
      return "";
    }
  };

  customRender_SingleUse = (tableField) => {
    if (tableField !== undefined) {
      if (tableField == 0) {
        return "<span><center>" + "-" + "</center></span>";
      } else {
        return "<span><center>" + this.gridTextSingleUsed + "</center></span>";
      }
      //return '<Chip label="'+ tableField +'" color="secondary" />';
    } else {
      return "";
    }
  };

  customRender_usedLastdate = (tableField) => {
    if (tableField !== undefined && tableField != null) {
      try {
        const lastOrder = new Date(tableField);

        const diff = differenceInDays(new Date(), lastOrder);
        const lastDate = lastOrder.toLocaleString();

        if (diff === 0) {
          // current day
          return "<span style='color: #00a000;'>" + lastDate + "</span>"; // green
        } else {
          return lastDate;
        }
      } catch (e) {
        console.error(e);
        return null;
      }
    } else {
      return null;
    }
  };

  handleMultieSelect = (ids) => {
    this.setState({ selectedIds: ids });
  };

  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  render() {
    const { classes } = this.props;

    const showActiveFilter = [
      {
        value: "ALL",
        label: getTranslation("vouchers" + "." + "filters.setview.filterOffActive", "FILTER UIT (active/in-active)"),
      },
      {
        value: "0",
        label: getTranslation("vouchers.filters.setview.active", "Alleen actieve vouchers"),
      },
      {
        value: "1",
        label: getTranslation("vouchers.filters.setview.non-active", "Alleen in-actieve vouchers"),
      },
    ];
    const showActiveOptions = convertArrayToSelectOptions(showActiveFilter, classes);

    const showSingleUseFilter = [
      {
        value: "ALL",
        label: getTranslation(
          "vouchers" + "." + "filters.setview.filterOffSingleUse",
          "FILTER UIT (eenmalige/meervoudige)"
        ),
      },
      {
        value: "0",
        label: getTranslation("vouchers.filters.setview.singleUse", "Alleen eenmalige vouchers"),
      },
      {
        value: "1",
        label: getTranslation("vouchers.filters.setview.non-singleUse", "Alleen meervoudige vouchers"),
      },
    ];
    const showSingleUseOptions = convertArrayToSelectOptions(showSingleUseFilter, classes);

    let actions = [
      {
        icon: CenterFocusStrong,
        tooltip: <TranslationWrapper tDefault={"Download QR"} tKey={"tafels.table.tooltip.downloadQr"} />,
        actionType: "download",
        action: "/qrs/code/genvoucher/:id?download=true",
      },
    ];

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Korting Vouchers"} tKey={"vouchers.pagetitle"} />} />

        <GridContainer>
          <GridItem xs={12}>
            {this.props.vestiging_id ? (
              <AuthenticationWrapper permissionKey={"vouchers.create"}>
                <Link to={"./create"}>
                  <Button className={classes.marginRight} color={"success"}>
                    <Add className={classes.icons} />{" "}
                    <TranslationWrapper tDefault={"New voucher-ticket"} tKey={"vouchers.nieuw.item"} />
                  </Button>
                </Link>
              </AuthenticationWrapper>
            ) : null}
          </GridItem>

          {this.state.selectedIds.length > 0 ? (
            <GridItem>
              <Button
                className={classes.marginRight}
                color={"success"}
                onClick={() => this.toggleModal("DownloadQRCodeModal")}
              >
                <CenterFocusStrong className={classes.icons} />{" "}
                <TranslationWrapper tDefault={"QRcodes"} tKey={"tafels.downloadQrCode"} />
              </Button>

              <AuthenticationWrapper permissionKey={"voucherDefs.delete"}>
                <Button
                  className={classes.marginRight}
                  color={"danger"}
                  onClick={() => {
                    const data = {
                      ids: this.state.selectedIds,
                    };

                    axios.post("core/vouchers/multipledelete", data).then((response) => {
                      const aantal = response.data.data.deleted;
                      this.setState({ selectedIds: [] });
                      this.toggleModal("showDeleteAlert");
                      toast.warn(aantal + " items verwijderd");
                      this.jamezzTable.current?.refreshData();
                    });
                  }}
                >
                  <DeleteForeverRounded className={classes.icons} />
                  <TranslationWrapper tKey={"Delete selected"} />
                </Button>

                <Button className={classes.marginRight} color={"info"} onClick={this.downloadVoucherCodes}>
                  <SaveAlt className={classes.icons} />{" "}
                  <TranslationWrapper tDefault={"Exporteer kortingscodes"} tKey={"tafels.exportVoucherCodes"} />
                </Button>
              </AuthenticationWrapper>
            </GridItem>
          ) : null}
        </GridContainer>

        {/* Filters */}
        <GridContainer>
          {/* Sales Area Filter */}
          <VestigingenFilter />
          {/* Custom Filter: Dropdown: All/Active/Non-active  */}
          <GridItem sm={4} xs={12}>
            <FormControl className={classes.selectFormControl} fullWidth>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                inputProps={{
                  name: "simpleSelect",
                  id: "simple-select",
                  style: { paddingTop: "32px" },
                }}
                onChange={(e) => {
                  switch (e.target.value) {
                    case "ALL":
                      this.props.setFilter("vouchers:active", null);
                      break;
                    case "0":
                      this.props.setFilter("vouchers:active", {
                        field: "active",
                        operator: "=",
                        value: 1,
                        selectValue: "0",
                      });
                      break;
                    case "1":
                      this.props.setFilter("vouchers:active", {
                        field: "active",
                        operator: "=",
                        value: 0,
                        selectValue: "1",
                      });
                      break;
                  }
                }}
                value={this.props.filters["vouchers:active"]?.selectValue ?? "ALL"}
              >
                {showActiveOptions}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem sm={4} xs={12}>
            <FormControl className={classes.selectFormControl} fullWidth>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                inputProps={{
                  name: "simpleSelect",
                  id: "simple-select",
                  style: { paddingTop: "32px" },
                }}
                onChange={(e) => {
                  switch (e.target.value) {
                    case "ALL":
                      this.props.setFilter("vouchers:type", null);
                      break;
                    case "0":
                      this.props.setFilter("vouchers:type", {
                        field: "type",
                        operator: "=",
                        value: "SINGLE_USE",
                        selectValue: "0",
                      });
                      break;
                    case "1":
                      this.props.setFilter("vouchers:type", {
                        field: "type",
                        operator: "=",
                        value: "MULTI_USE",
                        selectValue: "1",
                      });
                      break;
                  }
                }}
                value={this.props.filters["vouchers:type"]?.selectValue ?? "ALL"}
              >
                {showSingleUseOptions}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem sm={4} xs={12}>
            <FormControl className={classes.selectFormControl} fullWidth>
              <TextField
                label={"Total number of redemptions allowed"}
                onChange={(e) => {
                  const number = Number.parseInt(e.target.value);
                  if (e.target.value == "" || Number.isNaN(number)) {
                    this.props.setFilter("vouchers:total_redemptions_allowed", null);
                  } else {
                    this.props.setFilter("vouchers:total_redemptions_allowed", {
                      field: "total_redemptions_allowed",
                      operator: "=",
                      value: number,
                    });
                  }
                }}
                value={this.props.filters["vouchers:total_redemptions_allowed"]?.value}
              />
            </FormControl>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={actions}
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "active", editable: true, inputtype: "Switch" },
                { dbfield: "vestiging.naam", editable: false },
                { dbfield: "voucherdef.title", editable: false },
                { dbfield: "vouchercode", editable: false },
                {
                  dbfield: "type",
                  editable: false,
                },
                {
                  dbfield: "total_redemptions_allowed",
                  editable: false,
                },
                { dbfield: "usedCounter", editable: false },
                {
                  dbfield: "usedLastdate",
                  customRender: this.customRender_usedLastdate,
                },
                { dbfield: "usedDayCounter", editable: false },
                { dbfield: "final", customRender: this.customRender_final },
              ]}
              dbfields={
                "id,active,vestiging_id,vestiging.id,vestiging.naam,voucherdef_id,voucherdef.id,voucherdef.title,vouchercode,type,total_redemptions_allowed,usedCounter,usedLastdate,usedDayCounter,final"
              }
              delete={"vouchers.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"vouchers/:id/edit"}
              fetchUrl={"core/vouchers"}
              filters={this.props.filters}
              headerIcon={<ConfirmationNumber />}
              headers={[
                {
                  label: getTranslation("vouchers.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("vouchers.table.active", "Actief"),
                  sortable: true,
                  sortKey: "active",
                },
                {
                  label: getTranslation("vouchers.table.verkoopgebied", "Verkoopgebied"),
                  sortable: true,
                  sortKey: "vestiging.naam",
                },
                {
                  label: getTranslation("vouchers.table.voucherdefinition", "Kortings-Definitie"),
                  sortable: true,
                  sortKey: "voucherdef_id",
                },
                {
                  label: getTranslation("vouchers.table.vouchercode", "Code"),
                  sortable: true,
                  sortKey: "vouchercode",
                },
                {
                  label: getTranslation("vouchers.table.type", "Voucher type"),
                  sortable: true,
                  sortKey: "type",
                },
                {
                  label: getTranslation("vouchers.table.total_redemptions_allowed", "Total redemptions allowed"),
                  sortable: true,
                  sortKey: "total_redemptions_allowed",
                },
                {
                  label: getTranslation("vouchers.table.usedCounter", "Counter total"),
                  sortable: true,
                  sortKey: "usedCounter",
                },
                {
                  label: getTranslation("vouchers.table.usedLastdate", "Lastdate used"),
                  sortable: true,
                  sortKey: "usedLastdate",
                },
                {
                  label: getTranslation("vouchers.table.usedDayCounter", "Counter lastdate"),
                  sortable: true,
                  sortKey: "usedDayCounter",
                },
                {
                  label: getTranslation("vouchers.table.final", "final"),
                  sortable: true,
                  sortKey: "final",
                },
              ]}
              multieSelect
              multieSelectHandler={this.handleMultieSelect}
              reduxKey={"vouchers"}
              ref={this.jamezzTable}
              refreshTable={() => this.jamezzTable.current?.refreshData()}
              tableTitle={<TranslationWrapper tDefault={"Korting-Vouchers"} tKey={"vouchers.table.titel"} />}
            />
          </GridItem>
        </GridContainer>

        <DownloadVoucherQRCodes
          open={this.state.DownloadQRCodeModal}
          selectedTafelIds={this.state.selectedIds}
          toggle={() => this.toggleModal("DownloadQRCodeModal")}
          {...this.props}
        />
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);
  if (state.filtersV2["vouchers:type"]) {
    filters["vouchers:type"] = state.filtersV2["vouchers:type"];
  }
  if (state.filtersV2["vouchers:total_redemptions_allowed"]) {
    filters["vouchers:total_redemptions_allowed"] = state.filtersV2["vouchers:total_redemptions_allowed"];
  }
  if (state.filtersV2["vouchers:active"]) {
    filters["vouchers:active"] = state.filtersV2["vouchers:active"];
  }
  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, tafelStyle));
